import React, { useState, useEffect } from "react";
import { Grid, Button, Menu, MenuItem } from "@mui/material";
import { ViewColumn } from "@mui/icons-material";
import { toast } from "react-toastify";
import gridColSettingStore from "../../../Stores/GridColumn_SettingStores";
import GridColSettingConstants from "../../../Constants/GridColumn_SettingConstants";
import GridColumnSettingControl from "../../FilterOptions/GridColumnSettingControl";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import { useLanguageContext } from "../../../Context/LanguageContext";
import { useItemSelectedFilterContext } from "../../../Context/GridEquipListContext";
export default function GridColumnServerConfigButton({
  label,
  name,
  reportCode,
  handleGridSettingChange,
}) {
  const itemSelectedFilter = useItemSelectedFilterContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();

  const [showGridColumn, setShowGridColumn] = useState(false);

  useEffect(() => {
    function getColSettingSaveSuccess() {
      var res = gridColSettingStore.getGridColSettingSaveResult();

      if (res) {
        // setConditions([]);
        handleGridSettingChange(itemSelectedFilter);
        setShowGridColumn(false);
        toast.success(localization.saveSuccessMsg);
      }
    }

    function getColSettingSaveFailure() {
      var res = gridColSettingStore.getGridColSettingSaveResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.SAVE_GRID_SETTING_SUCCESS,
      getColSettingSaveSuccess
    );

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.SAVE_GRID_SETTING_FAILURE,
      getColSettingSaveFailure
    );
    return () => {
      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.SAVE_GRID_SETTING_SUCCESS,
        getColSettingSaveSuccess
      );

      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.SAVE_GRID_SETTING_FAILURE,
        getColSettingSaveFailure
      );
    };
  }, []);

  function handleButtonClick(e, functionName) {
    switch (functionName) {
      case "DataConfiguration":
        setGlobalSpinner(true);
        setShowGridColumn(true);
        break;
      //  case "ExcelExport":
      //    downloadEvent(e);
      //    break;
    }
  }

  function handleCloseGridColSettingModal() {
    setShowGridColumn(false);
  }

  return (
    <>
      <Button
        startIcon={<ViewColumn />}
        variant="contained"
        className="gridTableButton gridTableButtonStyle"
        onClick={(e) => handleButtonClick(e, name)}
      >
        {label}
      </Button>

      {showGridColumn && (
        <GridColumnSettingControl
          pageId={reportCode}
          handleCloseModel={handleCloseGridColSettingModal}
        />
      )}
    </>
  );
}
